<template>
  <layout-vertical>

    <router-view :key="$route.path" />

    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar
        id="navbar-header"
        :toggle-vertical-menu-active="toggleVerticalMenuActive"
      />
    </template>
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import Navbar from '../components/Navbar.vue'

export default {
  components: {
    LayoutVertical,
    Navbar,
  },
}
</script>
